import React from 'react';

import { useFullLayoutContext } from '../context';

import { Item } from '@/components/ui/item';
import { cn } from '@/lib/utils';

export function Main({ children, className }: { children?: React.ReactNode; className?: string }) {
  const ctx = useFullLayoutContext();
  const mainIsScrollContainer = ctx?.disableMainScrollArea ?? false;

  return (
    <Item
      className={cn(
        'p-0',
        mainIsScrollContainer &&
          'h-[calc(100dvh-var(--header-nav-height))] md:h-[calc(100dvh-var(--header-nav-height)-1rem)] min-h-0 overflow-y-auto p-4 md:p-8',
        className,
      )}
    >
      {children}
    </Item>
  );
}
Main.displayName = 'FullLayout.Main';
